import styled from "styled-components";

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  margin: 120px 64px;
  row-gap: 60px;

  @media (max-width: 768px) {
    margin: 40px 16px;
    row-gap: 32px;
  }
`;
